import { categories } from "../../data/product";

export default function categoryLabel(category) {
  const found = categories.find((c) => c.value === category);
  const label = found ? found.label : category || "";
  return label ? `${label.toUpperCase()}S` : "";
}
